import { HttpMethod } from "./http";

export class ApiRequestAdapter {
  private constructor(
    readonly url: string,
    readonly method: HttpMethod,
  ) {}

  static create = (url: string, method: HttpMethod) => new ApiRequestAdapter(url, method);

  getParametrizedUrl(...params: string[]) {
    return params.reduce((url, param, index) => url.replace(`{${index}}`, param), this.url);
  }
}
